import { Dispatch } from 'redux';
import * as actionTypes from '../action-types';
import {
  getUserWatchers,
  createWatcherRequest,
  deleteWatcherRequest,
} from '../../watchers.api';
import {
  WatcherEntityItem,
  NewWatcherEntityQueryParams,
} from '../../watchers.types';

const setUserWatchers = (watchers: Array<WatcherEntityItem>) =>
  <const>{
    type: actionTypes.SET_USER_WATCHERS,
    payload: { watchers },
  };

const setUserWatcher = (watcher: WatcherEntityItem) =>
  <const>{
    type: actionTypes.SET_USER_WATCHER,
    payload: { watcher },
  };

const unsetUserWatcher = (watcher: WatcherEntityItem) =>
  <const>{
    type: actionTypes.UNSET_USER_WATCHER,
    payload: { watcher },
  };

export const fetchUserWatchers = () => async (dispatch: Function) => {
  const { data } = await getUserWatchers();
  dispatch(setUserWatchers(data));
};

export const createUserWatcher = (
  queryParams: NewWatcherEntityQueryParams,
  uniqueId: string,
) => async (dispatch: Dispatch) => {
  const data = await createWatcherRequest(queryParams);
  dispatch(setUserWatcher({ uniqueId, key: data.key }));
  return data;
};

export const deleteUserWatcher = (uniqueId: string) => async (
  dispatch: Function,
  getState: Function,
) => {
  const {
    userWatchers: { map },
  } = getState();
  const watcher = map[uniqueId];
  if (watcher && watcher.key) {
    await deleteWatcherRequest(watcher.key);
    dispatch(unsetUserWatcher(watcher));
    return watcher.key;
  }
  return undefined;
};

export type UserWatchersActions = ReturnType<
  typeof setUserWatchers | typeof setUserWatcher | typeof unsetUserWatcher
>;
